module.exports = __webpack_public_path__ + "static/sport/img-swiper4.2c4803c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/img-swiper4.png
// module id = gYW5
// module chunks = 0